<template>
  <div class="d-flex flex-wrap align-items-center">
    <slot></slot>
  </div>
</template>
<script>
export default {
}
</script>
